import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import classes from './service.module.scss';

interface detailsProps {
    Item: string;
    ListItem?: boolean;
    Sublist?: Array<detailsProps>;
}

export interface ServiceAccordionProps {
    Summary: string;
    Details?: Array<detailsProps>;
}


export const ServiceAccordion: React.FC<ServiceAccordionProps> = React.memo(
    ({ Summary, Details }) => {
        const [expanded, setExpanded] = React.useState<string | false>(false);

        const handleChange = (panel: string) => () => {
            setExpanded(panel === expanded ? false : panel);
        };
        return (
            <Accordion
                expanded={expanded === Summary}
                // disabled={!details}

                onChange={Details ? handleChange(Summary) : () => {}}
                className={classes.service__accordion}
                style={{ cursor: Details ? 'pointer' : 'context-menu' }}
            >
                <AccordionSummary
                    expandIcon={Details && <ExpandMore />}
                    aria-controls={Summary}
                    id={Summary}
                    style={{
                        borderBottom: '1px solid rgba(0, 0, 0, .125)',
                        cursor: Details ? 'pointer' : 'context-menu'
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '1.1rem',
                            fontWeight: 600
                        }}
                    >
                        {Summary}
                    </Typography>
                </AccordionSummary>
                {Details && (
                    <AccordionDetails
                        className={classes.service__accordion__details}
                    >
                        <ul className={classes.service__accordion__details__list}>
                            {Details.map((detail, index) => (
                                <React.Fragment key={index}>
                                    <li
                                        className={
                                            detail.ListItem
                                                ? classes.service__accordion__details__list__itemBullet
                                                : classes.service__accordion__details__list__item
                                        }
                                    >
                                        {detail.Item}
                                    </li>
                                    {detail.Sublist && (
                                        <ul
                                            className={
                                                classes.service__accordion__details__list__sub
                                            }
                                        >
                                            {detail.Sublist.map(
                                                (subdetial, index) => (
                                                    <li key={index}>
                                                        {subdetial.Item}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    )}
                                </React.Fragment>
                            ))}
                        </ul>
                    </AccordionDetails>
                )}
            </Accordion>
        );
    }
);
